module.exports = __webpack_public_path__ + "static/img/KRAKEN.a0c8782.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/KRAKEN.jpg
// module id = EsQN
// module chunks = 1